module.exports = require("bluebird/js/main/captured_trace")();



//////////////////
// WEBPACK FOOTER
// ./node_modules/request-promise/lib/bluebird-captured-trace-fresh.js
// module id = 461
// module chunks = 0